export default {
  location: [1, 2],
  bgColor: '#f7f8fb',
  pcBgColor: '#ffffff',
  pathLink: [],
  pcHeight: 149,
  pcSizeNum: 4,
  pcBannerSpace: 9,
  pcBannerVerticalSpace: 0,
  pcDynamic: true,
  mHeight: 60,
  mSizeNum: 2,
  mBannerSpace: 11,
  mBannerVerticalSpace: 0,
  mHorizontalPadding: 11,
  pcHorizontalPadding: 0
};